import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { MaterialSymbol } from '@ui2/icons'
import { FormulaPlainTextField } from '@ui/forms'

interface Props {
  value?: string
  onChange?: (value: string) => void
}

const Results2CommentField = ({ value, onChange }: Props): ReactElement => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
    <Box
      component="label"
      sx={{
        fontSize: 11,
        color: 'text.secondary',
        fontFamily: 'Roboto',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
      }}
    >
      Kommentar Positionsliste
      <MaterialSymbol icon="description" size={14} sx={{ color: 'rgba(0,0,0,0.38)' }} />
    </Box>
    <FormulaPlainTextField
      value={value ?? ''}
      onChange={next => onChange?.(next)}
      placeholder="Kommentar eingeben…"
    />
  </Box>
)

export default Results2CommentField
